<template>
    <div class="w-1/2 pl-2 md:pl-0">
        <template v-if="is_public">
            <router-link
                :to="{ name: 'home' }"
                @click.native="$router.go()"
                class="text-2xl lg:text-4xl no-underline hover:no-underline font-bold"
                data-cy="main-logo"
            >
                <img class="inline-block h-7 lg:h-10" :src="'/images/icon-cover-vault.png'" alt="logo" />
                <span class="text-black">Cover</span><span class="text-white">Vault</span>
            </router-link>
        </template>
        <template v-if="!is_public">
            <router-link
                v-if="displayEpicLogo"
                :to="{ name: 'home' }"
                class="text-2xl lg:text-4xl no-underline hover:no-underline font-bold pb-2"
                data-cy="main-logo"
            >
                <img class="inline-block h-7 lg:h-10" :src="'/images/icon-epic-vault.png'" alt="logo" />
                <span class="text-black">Epic</span><span class="text-default-blue">Vault</span>
            </router-link>
            <router-link
                v-if="displayClaimsLogo"
                :to="{ name: 'home-claims' }"
                class="text-2xl lg:text-4xl no-underline hover:no-underline font-bold pb-2"
                data-cy="main-logo"
            >
                <img class="inline-block h-7 lg:h-10" :src="'/images/icon.png'" alt="logo" />
                <span class="text-black">Claims</span><span class="text-default-purple">Vault</span>
            </router-link>
            <router-link
                v-else-if="displayCoverLogo"
                :to="{ name: 'home-cover' }"
                class="text-2xl lg:text-4xl no-underline hover:no-underline font-bold pb-2"
                data-cy="main-logo"
            >
                <img class="inline-block h-7 lg:h-10" :src="'/images/icon-cover-vault.png'" alt="logo" />
                <span class="text-black">Cover</span><span class="text-default-blue-green">Vault</span>
            </router-link>
        </template>
        <img
            v-if="currentAssociationLogo !== null"
            class="inline ml-6 max-h-16 max-w-16"
            :src="currentAssociationLogo"
            alt="association logo"
            data-cy="header-association-logo"
        />
    </div>
</template>

<script>
export default {
    computed: {
        currentAssociationLogo() {
            return this.$store.getters['user/currentAssociationLogo'];
        },
        currentNavLink() {
            return this.$store.state.navigation.current_link;
        },
        displayClaimsLogo() {
            return (this.is_epic_vault_enabled && this.currentNavLink === 'claim') || !this.is_epic_vault_enabled;
        },
        displayCoverLogo() {
            return this.is_epic_vault_enabled && this.currentNavLink === 'cover';
        },
        displayEpicLogo() {
            return this.is_epic_vault_enabled && this.currentNavLink !== 'claim' && this.currentNavLink !== 'cover';
        },
    },
    props: {
        is_epic_vault_enabled: {
            type: Boolean,
            default: false,
        },
        is_public: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
